import { RoleType } from 'api-user-client'

import { ApplicationUser } from '~shared-components/transforms/user.transforms'
import { Page } from '~shared-components/utils/enums'

export const isAllowedToSeePage = (
  page: Page,
  user: ApplicationUser | undefined,
) => {
  switch (page) {
    case Page.Invoices:
      return user && user.isRoleAbove(RoleType.UserManager, true)
    case Page.Users:
      return user && user.isRole(RoleType.UserAdmin)
    default:
      return false
  }
}
